import { required } from 'vee-validate/dist/rules';

export default {
  ...required,
  message: 'Please ensure the date of birth is correct.',
};
